import SeoPage from "../components/SeoPage";

export default function AI() {
  return (
    <SeoPage
      title="AI Development Company | Arviko"
      description="AI-powered software solutions and automation."
      heading="AI Development Company"
    >
      <p>
        We build AI-powered applications for automation and intelligence.
      </p>
    </SeoPage>
  );
}